import nominees from './nominees'
import categories from './categories'

const nomineesData = { ...nominees, ...categories }

export default nomineesData
